import React, { useEffect, useState } from 'react'
import Layout from '../../components/auth/layout'
import Form from '../../components/auth/forgot-password'
import { v1_forgot_password, } from '../../actions/v1/auth'
import swal from 'sweetalert';
import { getSessionStorage, setSessionStorage } from '../../utils';
import constant from '../../constant';

const Login = () => {
    const [message, setMessage] = useState('');
    const onLogin = (model) => {
        v1_forgot_password(model).then(res => {
            if (res.status) {
                setSessionStorage(constant.keys.forgorPassword, res.result.message);
                setMessage(res.result.message)
            }
            else {
                swal({
                    title: res.error,
                    icon: "warning",
                    dangerMode: true,
                })
            }
        })
    };

    useEffect(() => {
        if (getSessionStorage(constant.keys.forgorPassword)) {
            setMessage(getSessionStorage(constant.keys.forgorPassword))
        }
    }, []);

    return (
        <React.Fragment>
            <Layout>
                <Form
                    message={message}
                    onSubmit={onLogin}
                />
            </Layout>
        </React.Fragment>)
}

export default Login